import { render, staticRenderFns } from "./RegWechat.vue?vue&type=template&id=e635fc4e&scoped=true"
import script from "./RegWechat.vue?vue&type=script&lang=js"
export * from "./RegWechat.vue?vue&type=script&lang=js"
import style0 from "./RegWechat.vue?vue&type=style&index=0&id=e635fc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e635fc4e",
  null
  
)

export default component.exports